export default function parseWindcaveReceipt(receipt: string) {
  const processReceipt = [];
  for (let i = 0; i < receipt.length; i++) {
    let tmpLine = receipt.slice(i, i + 26);
    tmpLine = tmpLine.toString().replace(/\s{2,}/g, '\n');
    // const lineSplit = tmpLine.split('\n');
    // console.log(lineSplit);
    // TODO -- if formatting is required
    // currentLine = `${formattedItem[0]}${' '.repeat(
    //   40 - formattedItem[0].length - replacePounds.length,
    // )}${replacePounds}`;

    // Length of the receipt lines is 27 so easiest way to do it is splitting the lines
    processReceipt.push(receipt.slice(i, i + 26));
    i = i + 26;
  }
  let formattedReceipt = processReceipt.join('\n');
  formattedReceipt = formattedReceipt.replace('APP LABEL', 'Kiosk');
  formattedReceipt = formattedReceipt.replace(/\sAUD/g, 'AUD ');

  return formattedReceipt;
}
